import { useEffect, useState } from 'react';
import { httpGet, httpPut } from '@/utils/helpers/httpHelper';
import CONFIG from 'config';
import Image from 'next/image';
import { formatUrlForHttp } from '@/utils/helpers/urlFormatter';

interface IProps {
  type: 'desktop' | 'mobile';
  template: 'services' | 'header' | 'footer' | 'middle';
  size?: 'default' | 'small';
}

const AdBanner: React.FC<IProps> = ({ template, type, size = 'default' }) => {
  const [currentAd, setCurrentAd] = useState(null);
  const getBanners = async () => {
    const { data } = await httpGet(`${CONFIG.ENDPOINTS.ads}?device=${type}`);
    return setCurrentAd(data?.data?.find((e: any) => e.template === template));
  };
  useEffect(() => {
    getBanners();
  }, []);

  const adClickHandler = async (id: string) => {
    const { data } = await httpPut(`${CONFIG.ENDPOINTS.ads}${id}/click`, null);
    if (data.success) getBanners();
  };

  return (
    <div className=' mt-[10px] cursor-pointer'>
      <a
        href={currentAd && formatUrlForHttp(currentAd.targetUrl)}
        target='_blank'
        rel='noreferrer'
        // onClick={() => bannerClickHandler(i, e)}
      >
        {currentAd ? (
          type === 'desktop' ? (
            <div className='max-w-[970px] max-h-[90px] mx-auto'>
              <Image
                src={CONFIG.ENDPOINTS.imageBasePath + currentAd.imagePath}
                role='presentation'
                layout='responsive'
                width={970}
                height={90}
                onClick={() => {
                  adClickHandler(currentAd.id);
                }}
              />
            </div>
          ) : size === 'default' ? (
            <div className='max-w-[320px] max-h-[100px] mx-auto'>
              <Image
                src={CONFIG.ENDPOINTS.imageBasePath + currentAd.imagePath}
                role='presentation'
                layout='responsive'
                width={320}
                height={100}
                onClick={() => {
                  adClickHandler(currentAd.id);
                }}
              />
            </div>
          ) : (
            <div className='max-w-[320px] max-h-[50px] mx-auto'>
              <Image
                src={CONFIG.ENDPOINTS.imageBasePath + currentAd.imagePath}
                role='presentation'
                layout='responsive'
                width={320}
                height={50}
                onClick={() => {
                  adClickHandler(currentAd.id);
                }}
              />
            </div>
          )
        ) : null}
      </a>
    </div>
  );
};

export default AdBanner;
